export const DEFAULT_ELEARNING_SETTINGS = {
  elearningBookmarkEnable: false,
  courseTrackingEnable: false,
  videoLibraryEnabled: true,
  libraryEnabled: false,
} as const;

export const ERROR_MESSAGES = {
  MISSING_TOKEN: 'Missing Breathe token. Please use a valid link.',
  SESSION_EXPIRED:
    'Your session has expired. Please request a new link from Breathe.',
  FAILED_TO_LAUNCH: 'Failed to launch course. Please try again.',
  COMPLETION_FAILED: 'Completion could not be recorded. Please try again.',
} as const;

export const QUIZ_START_DEBOUNCE_MS = 2000;
export const SCORE_PERCENTAGE_BASE = 100;
export const DEFAULT_QUESTION_COUNT = 1;
